/* KILLIK — the spirits list: a Rum | Gin toggle, and on touch screens the row nearest the middle of
   the screen lights up as you scroll (there's no hover on a phone). Gin rows jump to that gin in the
   swipe section. */
(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const touch = matchMedia('(hover: none)').matches;

  function init(sec) {
    if (!sec || sec.dataset.ready) return;
    sec.dataset.ready = '1';
    const tabs = [...sec.querySelectorAll('[data-range]')];
    const lists = [...sec.querySelectorAll('[data-list]')];
    let queued = false;

    function lit() {
      queued = false;
      if (!touch) return;
      const mid = innerHeight / 2;
      let best = null, bd = innerHeight * 0.3;
      lists.forEach(list => {
        [...list.children].forEach(r => r.classList.remove('on'));
        if (list.hidden) return;
        for (const r of list.children) {
          const b = r.getBoundingClientRect(), d = Math.abs(b.top + b.height / 2 - mid);
          if (d < bd) { bd = d; best = r; }
        }
      });
      best?.classList.add('on');
    }
    function show(range) {
      tabs.forEach(t => t.setAttribute('aria-selected', String(t.dataset.range === range)));
      lists.forEach(l => { l.hidden = l.dataset.list !== range; });
      lit();
    }
    tabs.forEach(t => t.addEventListener('click', () => show(t.dataset.range)));

    // a gin row scrolls to the swipe section and lands on that gin
    sec.addEventListener('click', e => {
      const row = e.target.closest('[data-gin]');
      if (!row) return;
      const gin = document.getElementById('gin');
      if (!gin) return;
      e.preventDefault();
      gin.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
      setTimeout(() => gin.dispatchEvent(new CustomEvent('gin:show', { detail: +row.dataset.gin })), reduced ? 0 : 450);
    });

    addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(lit); } }, { passive: true });
    lit();
  }

  const initAll = (root = document) => root.querySelectorAll('[data-spirits-list]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load', e => initAll(e.target));
})();
